import m from "../../geodata/es2015/ukLow";
window.am4geodata_ukLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/ukLow.js
// module id = null
// module chunks = 